// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4647":"84c13497","9479":"15de74df"}[chunkId] + ".chunk.css";
};